import { useState } from "react";
import { api, ApiClientError } from "../../lib/apiClient.js";
import { Button } from "../ui/button.js";
import { Modal } from "../ui/modal.js";
import { TextInput } from "../ui/field.js";
import { useToast } from "../../lib/useToast.js";
import { useI18n } from "../../i18n/index.js";

export function SupplierDialog({
  open,
  onOpenChange,
  onCreated,
}: {
  open: boolean;
  onOpenChange(open: boolean): void;
  onCreated(): void;
}) {
  const { push } = useToast();
  const { t } = useI18n();
  const [form, setForm] = useState({
    code: "",
    name: "",
    contactName: "",
    phone: "",
    email: "",
    paymentNote: "",
  });

  const submit = async () => {
    try {
      await api.createSupplier(form);
      push(t("purchasing.addedToast"), form.name);
      setForm({
        code: "",
        name: "",
        contactName: "",
        phone: "",
        email: "",
        paymentNote: "",
      });
      onOpenChange(false);
      onCreated();
    } catch (err) {
      if (err instanceof ApiClientError) push(err.message, undefined, "danger");
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t("purchasing.addSupplierTitle")}
      footer={
        <>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
          <Button
            variant="primary"
            onClick={submit}
            disabled={!form.code.trim() || !form.name.trim()}
          >
            {t("purchasing.saveSupplier")}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <div className="grid gap-3 sm:grid-cols-2">
          <TextInput
            label={t("common.fields.code")}
            value={form.code}
            onChange={(e) => setForm((f) => ({ ...f, code: e.target.value }))}
          />
          <TextInput
            label={t("common.fields.name")}
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          />
        </div>
        <TextInput
          label={t("purchasing.contact")}
          value={form.contactName}
          onChange={(e) => setForm((f) => ({ ...f, contactName: e.target.value }))}
        />
        <div className="grid gap-3 sm:grid-cols-2">
          <TextInput
            label={t("common.fields.phone")}
            type="tel"
            value={form.phone}
            onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
          />
          <TextInput
            label={t("common.fields.email")}
            type="email"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          />
        </div>
        <TextInput
          label={t("purchasing.paymentNote")}
          value={form.paymentNote}
          onChange={(e) => setForm((f) => ({ ...f, paymentNote: e.target.value }))}
        />
      </div>
    </Modal>
  );
}
